import React from "react";
import { Button, Card, Form, Col, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Label } from "reactstrap";
import Moment from "moment";
import "moment/locale/id";
import { getListKategoriJson } from "stores/Pengajuan/function";

function Step1() {
  const dispatch = useDispatch();

  const pengajuan = useSelector((state) => state.pengajuanReducer);
  // console.log(pengajuan, "IIII");
  const valDetail = pengajuan.detailPengajuan;
  // console.log(valDetail, "VALDETAIL");
  const listJson = pengajuan.getListKategoriJson;
  Moment.locale("id");
  const tglLahir = Moment(valDetail.tglLahir).format("DD MMMM YYYY");
  const tglkeluarIdentitas = Moment(valDetail.tglKeluarIdentitas).format(
    "DD MMMM YYYY",
  );
  const tglBerlakuSampai = Moment(valDetail.masaBerlakuIdentitas).format(
    "DD MMMM YYYY",
  );
  const getLabel = (category, value) => {
    // Cek kalau master datanya ada
    const dataMaster = listJson && listJson[category];
    if (dataMaster && Array.isArray(dataMaster)) {
      const item = dataMaster.find((d) => String(d.value) === String(value));
      return item ? item.label : value || "-";
    }
    return value || "-";
  };

  const InfoItem = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted fw-bold mb-1 d-block"
        style={{ fontSize: "10px", textTransform: "uppercase" }}
      >
        {label}
      </label>
      <div
        className={`p-2 rounded ${isPrimary ? "bg-light border" : ""}`}
        style={{
          fontSize: "13px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  React.useEffect(() => {
    getListKategoriJson(dispatch);
  }, []);

  return (
    <Col md="12" className="mt-3">
      {/* <div
        style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden" }}
        className="custom-scrollbar pr-2"
      > */}
      <Row className="mt-3">
        <Col md="12">
          <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
            <Card.Body className="p-4">
              <div
                style={{
                  maxHeight: "550px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                className="custom-scrollbar pr-2"
              >
                <Row>
                  {/* --- SEKSI 1: IDENTITAS UTAMA --- */}
                  <Col md={12} className="mb-3">
                    <h6
                      className="text-primary fw-800 small uppercase"
                      style={{ letterSpacing: "1px" }}
                    >
                      Data Identitas
                    </h6>
                    <hr className="mt-1" />
                  </Col>
                  <InfoItem
                    label="Reference ID"
                    value={valDetail.id_pinjaman}
                    isPrimary
                  />
                  <InfoItem
                    label="Nama Lengkap"
                    value={valDetail.namaLengkap}
                    isPrimary
                  />
                  <InfoItem
                    label="Jenis Identitas"
                    value={getLabel("jenisIdentitas", valDetail.jenisIdentitas)}
                  />
                  <InfoItem
                    label="Nomor Identitas"
                    value={valDetail.nomorIdentitas}
                  />
                  <InfoItem
                    label="Tempat Dikeluarkan"
                    value={valDetail.tempatDikeluarkanIdentitas}
                  />
                  <InfoItem label="Masa Berlaku" value={tglBerlakuSampai} />
                  <InfoItem
                    label="Tipe Nasabah"
                    value={getLabel("tipeNasabah", valDetail.tipeNasabah)}
                  />
                  <InfoItem
                    label="Tanggal Keluar Identitas"
                    value={tglkeluarIdentitas}
                  />

                  {/* --- SEKSI 2: INFORMASI PERSONAL --- */}
                  <Col md={12} className="mb-3 mt-4">
                    <h6
                      className="text-primary fw-800 small uppercase"
                      style={{ letterSpacing: "1px" }}
                    >
                      Informasi Personal
                    </h6>
                    <hr className="mt-1" />
                  </Col>
                  <InfoItem
                    label="Nama Panggilan"
                    value={valDetail.namaPanggilan}
                  />
                  <InfoItem
                    label="Tempat / Tgl Lahir"
                    value={`${valDetail.tempatLahir}, ${tglLahir}`}
                  />
                  <InfoItem
                    label="Jenis Kelamin"
                    value={getLabel("jenisKelamin", valDetail.jenisKelamin)}
                  />
                  <InfoItem
                    label="Agama"
                    value={getLabel("agama", valDetail.agama)}
                  />
                  <InfoItem
                    label="Pendidikan"
                    value={getLabel("pendidikan", valDetail.pendidikan)}
                  />
                  <InfoItem
                    label="Status Menikah"
                    value={getLabel("statusMenikah", valDetail.statusMenikah)}
                  />
                  <InfoItem
                    label="Gelar / SID Gelar"
                    value={`${valDetail.gelar || "-"} / ${getLabel("sidGelar", valDetail.sidGelar)}`}
                  />
                  <InfoItem
                    label="Nama Ibu Kandung"
                    value={valDetail.namaIbuKandung}
                  />

                  {/* --- SEKSI 3: KONTAK & ALAMAT --- */}
                  <Col md={12} className="mb-3 mt-4">
                    <h6
                      className="text-primary fw-800 small uppercase"
                      style={{ letterSpacing: "1px" }}
                    >
                      Alamat & Kontak
                    </h6>
                    <hr className="mt-1" />
                  </Col>
                  <InfoItem
                    label="Nomor Handphone"
                    value={valDetail.noHp}
                    color="#116D6E"
                  />
                  <InfoItem label="Email" value={valDetail.email} />
                  <InfoItem
                    label="Alamat KTP"
                    value={valDetail.alamatKtp}
                    col={12}
                  />
                  <InfoItem
                    label="RT / RW"
                    value={`${valDetail.rt} / ${valDetail.rw}`}
                  />
                  <InfoItem
                    label="Kelurahan / Kode Pos"
                    value={`${valDetail.kelurahan} / ${valDetail.kodepos}`}
                  />
                  <InfoItem
                    label="Domisili Sesuai KTP"
                    value={getLabel(
                      "domisiliSesuaiKtp",
                      valDetail.domisiliSesuaiKtp,
                    )}
                  />

                  {/* --- SEKSI 4: KEUANGAN & AHLI WARIS --- */}
                  <Col md={12} className="mb-3 mt-4">
                    <h6
                      className="text-primary fw-800 small uppercase"
                      style={{ letterSpacing: "1px" }}
                    >
                      Keuangan & Ahli Waris
                    </h6>
                    <hr className="mt-1" />
                  </Col>
                  <InfoItem
                    label="Biaya Hidup"
                    value={formatRupiah(valDetail.biayaHidup)}
                    color="#C62D42"
                  />
                  <InfoItem
                    label="Tanggungan Anak"
                    value={valDetail.jumlahTanggunganAnak}
                  />
                  <InfoItem
                    label="Tanggungan Ortu"
                    value={valDetail.jumlahTanggunganOrtu}
                  />
                  <InfoItem label="Nama Waris" value={valDetail.namaWaris} />
                  <InfoItem
                    label="Hubungan Waris"
                    value={valDetail.hubunganWaris}
                  />
                  <InfoItem
                    label="Alamat Waris"
                    value={valDetail.alamatWaris}
                    col={12}
                  />
                  {/* Tambahkan ini sebelum Tanggungan Anak */}
                  <InfoItem
                    label="Tanggungan Pasangan"
                    value={valDetail.jumlahTanggunganPasangan}
                  />
                </Row>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 5px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
        .fw-800 { font-weight: 800; }
        .mt--1 { margin-top: -5px; }
      `}</style>
      </Row>
      {/* </div> */}
    </Col>
  );
}
export default Step1;
